exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sales-link-view[data-v-2e8f48ee]{position:relative;margin:15px 10px 10px 10px;max-height:calc(100% - 25px);overflow:auto}", ""]);

// exports
